/* TIA · Favourites (wishlist)
   Stores product handles in localStorage under 'tia_favourites'.
   Works with:
     [data-fav-add]    — the Add/Saved toggle button (needs data-fav-handle)
     [data-fav-count]  — span that shows the saved count
     [data-fav-list]   — container on the Favourites page
*/
(function () {
  var KEY = 'tia_favourites';

  function read() {
    try { return JSON.parse(localStorage.getItem(KEY)) || []; }
    catch (e) { return []; }
  }
  function write(list) {
    try { localStorage.setItem(KEY, JSON.stringify(list)); } catch (e) {}
  }
  function has(handle) { return read().indexOf(handle) !== -1; }

  function toggle(handle) {
    var list = read();
    var i = list.indexOf(handle);
    if (i === -1) { list.push(handle); } else { list.splice(i, 1); }
    write(list);
    return i === -1;
  }

  function paintCounts() {
    var n = read().length;
    document.querySelectorAll('[data-fav-count]').forEach(function (el) {
      el.textContent = n ? '(' + n + ')' : '';
    });
  }

  function paintButton(btn, saved) {
    btn.setAttribute('aria-pressed', saved ? 'true' : 'false');
    var label = btn.querySelector('[data-fav-label]');
    if (label) label.textContent = saved ? 'Saved to favourites' : 'Add to favourites';
    btn.style.borderColor = saved ? '#9A7B4F' : '#CFC6B8';
    btn.style.color = saved ? '#7A5D33' : '#1A1A1A';
    var icon = btn.querySelector('[data-fav-icon]');
    if (icon) icon.textContent = saved ? '♥' : '♡';
  }

  function initButtons() {
    document.querySelectorAll('[data-fav-add]').forEach(function (btn) {
      var handle = btn.getAttribute('data-fav-handle');
      if (!handle) return;
      paintButton(btn, has(handle));
      btn.addEventListener('click', function (e) {
        e.preventDefault();
        paintButton(btn, toggle(handle));
        paintCounts();
      });
    });
  }

  /* Favourites page — fetch each saved product as a card. */
  function renderList() {
    var wrap = document.querySelector('[data-fav-list]');
    if (!wrap) return;
    var list = read();

    if (!list.length) {
      wrap.innerHTML =
        '<div style="grid-column:1/-1;text-align:center;padding:56px 16px;color:#6B655C">' +
        '<p style="font-size:16px;margin:0 0 18px">You haven\u2019t saved anything yet.</p>' +
        '<a href="/collections/all" style="display:inline-block;background:#1A1A1A;color:#F3EFE9;padding:15px 30px;' +
        'font-size:12.5px;letter-spacing:.1em;text-transform:uppercase;text-decoration:none;border-radius:2px">Start browsing</a></div>';
      return;
    }

    wrap.innerHTML = '';
    list.forEach(function (handle) {
      fetch('/products/' + handle + '.js')
        .then(function (r) { return r.ok ? r.json() : null; })
        .then(function (p) {
          if (!p) return;
          var img = p.featured_image
            ? '<img src="' + p.featured_image + '&width=600" alt="' + p.title +
              '" loading="lazy" style="position:absolute;inset:0;width:100%;height:100%;object-fit:contain;padding:12px;box-sizing:border-box">'
            : '';
          var card = document.createElement('div');
          card.innerHTML =
            '<a href="/products/' + handle + '" style="text-decoration:none;color:inherit;display:block">' +
            '<div style="position:relative;aspect-ratio:4/5;background:#FAF8F4;border:1px solid #E4DED4;border-radius:2px;overflow:hidden">' + img + '</div>' +
            '<div style="padding-top:12px;font-size:14.5px;color:#1A1A1A;line-height:1.4">' + p.title + '</div>' +
            '<div style="padding-top:4px;font-size:14px;color:#6B655C;font-variant-numeric:tabular-nums">$' + (p.price / 100).toFixed(2) + '</div>' +
            '</a>' +
            '<button data-fav-remove="' + handle + '" style="margin-top:8px;background:none;border:none;padding:0;' +
            'font-size:12px;letter-spacing:.06em;color:#9A9387;cursor:pointer;text-decoration:underline">Remove</button>';
          wrap.appendChild(card);

          card.querySelector('[data-fav-remove]').addEventListener('click', function () {
            toggle(handle);
            paintCounts();
            renderList();
          });
        })
        .catch(function () {});
    });
  }

  function boot() { initButtons(); paintCounts(); renderList(); }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }
})();
